import type { CustomerListRow } from "@/lib/admin-api/crm";
import type { CustomerSummary, LoyaltyTier } from "./types";

// ---------------------------------------------------------------------------
// Adapter — map the server row into the shape the UI renders
//
// `segment` is computed server-side (see customer_list_view in migration 079).
// We simply read it off the row; there is no client-side derivation.
// ---------------------------------------------------------------------------

export function toCustomerSummary(row: CustomerListRow): CustomerSummary {
  return {
    id: row.id,
    full_name: row.full_name || "Client sans nom",
    phone: row.phone || "",
    email: row.email || "",
    segment: row.segment,
    loyalty_tier: (row.loyalty_tier as LoyaltyTier) ?? "bronze",
    total_orders: row.total_orders,
    total_spent_fcfa: row.total_spent_fcfa,
    last_order_date: row.last_order_date
      ? new Date(row.last_order_date).toLocaleDateString("fr-SN")
      : null,
    preferred_payment: null,
    preferred_language: (row.preferred_language as "fr" | "wo" | "en") ?? "fr",
    addresses: [],
    tags: [],
    notes: [],
    member_since: new Date(row.created_at).toLocaleDateString("fr-SN"),
    region: row.region ?? "—",
  };
}
